import { useState } from "react";
import classnames from "classnames";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

export interface AramChampionStats {
  id: string;
  games: number;
  wins: number;
}

export interface AramChampStatsModuleProps {
  stats: AramChampionStats[];
}

export function ChampModule(props: AramChampionStats) {
  const { id, games, wins } = props;
  const winRate = games > 0 ? (wins / games) * 100 : 0;

  const { getChampionImg, getChampionName } = getRiotAssetsContext();
  const championUrl = getChampionImg(id);
  const championName = getChampionName(id);

  const getWinRateColor = (wr: number) => {
    if (wr >= 60) return "text-[#FF9B00]";
    if (wr >= 53) return "text-blue-400";
    if (wr >= 47) return "text-white";
    return "text-red-400";
  };

  const winRateColor = getWinRateColor(winRate);

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="w-[130px] h-[130px] rounded-full bg-gradient-to-b from-[#F4C874] to-[#D3A752] p-[3px] flex items-center justify-center shadow-lg">
        <div className="w-full h-full rounded-full bg-[#070720] p-[2px]">
          <div className="w-full h-full rounded-full overflow-hidden">
            <img src={championUrl} alt={championName} className="w-full h-full object-cover transform scale-[1.125]" />
          </div>
        </div>
      </div>
      <div className="text-white text-center font-barlow text-[24px]  font-semibold leading-normal uppercase">{games} Games</div>
      <div className="text-[#CDDCFE] text-center font-inter text-[16px]  font-normal leading-normal uppercase">
        {wins}W<span className="text-[#5C5C8E]"> / </span>
        {games - wins}L
      </div>
      <div
        className={classnames(
          "text-center font-inter text-[16px]  font-semibold leading-normal uppercase -mt-[16px]",
          winRateColor,
        )}
      >
        {winRate.toFixed(1)}% WR
      </div>
    </div>
  );
}

export function AramChampStatsModule({ stats }: AramChampStatsModuleProps) {
  const topChampions = [...stats].sort((a, b) => b.games - a.games).slice(0, 5);
  return (
    <div className="flex flex-col xs:flex-row items-center gap-[60px]">
      {topChampions.map((champ) => (
        <ChampModule key={champ.id} id={champ.id} games={champ.games} wins={champ.wins} />
      ))}
    </div>
  );
}
